module.exports = __webpack_public_path__ + "img/totaal-ontzorgd.1b7faa1ea8526106f194e41bbdec47a6.svg";